import { FC, useEffect, useState } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import IAuth from '../../Interfaces/Auth/IAuth'
import DSAuth from '../../Services/Auth/Auth.Services'
import DSUsers from '../../Services/Catalogos/CatUsuarios.Services'
import { useDispatch, useSelector } from 'react-redux'
import { populateUserProfile } from '../../store/features/Auth/UserProfileSlice'
import { populateMenuItems } from '../../store/features/Auth/MenuItemsSlice'
import { RootState } from '../../store/store'
import Leyend from '../../images/leyend.png'
import jwt_decode from 'jwt-decode'

interface IProps {}

export const ResetAccount: FC<IProps> = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const UserLogued = useSelector((state: RootState) => state.UserProfile.UserProfile.logueado)
  const [Usuario, setUsuario] = useState('')
  const [Contrasena, setContrasena] = useState('')
  const [Contrasena2, setContrasena2] = useState('')
  const [token, setToken] = useState<string>(
    (window.localStorage.getItem('token') ? window.localStorage.getItem('token') : '')!
  )
  const [menuStr, setMenuStr] = useState<string>(
    (window.localStorage.getItem('menu') ? window.localStorage.getItem('menu') : '')!
  )

  const Reset = async () => {
    if (Contrasena !== Contrasena2) {
      alert('Las contraseñas no coinciden entre si')
      return false
    }
    const data: IAuth = {
      usuario: Usuario,
      contrasena: Contrasena,
    }
    DSAuth.ResetPassword(data)
      .then((response) => {
        console.log(response.data)
        alert('El cambio de contraseña se realizo exitosamente!')
        navigate('/', { replace: true })
      })
      .catch((e: Error) => {
        alert('Credenciales invalidas! ')
      })
  }

  const validateToken = () => {
    DSAuth.Validate()
      .then((response) => {
        navigate('/login', { replace: true })
      })
      .catch((e: Error) => {
        alert('Ocurrio un error!')
      })
  }

  useEffect(() => {
    if (token.length > 5) {
      validateToken()
    }
  }, [token])

  return (
    <div hidden={token ? true : false}>
      <div className='Auth-form-container'>
        <form className='Auth-form'>
          <div className='Auth-form-content'>
            <h3 className='Auth-form-title'>
              <img src={Leyend} alt='' height='50' />
            </h3>
            <div className='form-group mt-3'>
              <label style={{ color: '#00719F', paddingLeft: '5px' }}>Usuario</label>
              <input
                type='email'
                className='form-control mt-1'
                placeholder='Usuario'
                onChange={(e) => {
                  setUsuario(e.target.value)
                }}
              />
            </div>
            <div className='form-group mt-3'>
              <label style={{ color: '#00719F' }}>Nueva contraseña</label>
              <input
                type='password'
                className='form-control mt-1'
                placeholder='Contraseña'
                onChange={(e) => {
                  setContrasena(e.target.value)
                }}
              />
            </div>
            <div className='form-group mt-3'>
              <label style={{ color: '#00719F' }}>Confirme nueva contraseña</label>
              <input
                type='password'
                className='form-control mt-1'
                placeholder='Contraseña'
                onChange={(e) => {
                  setContrasena2(e.target.value)
                }}
              />
            </div>
            <div className='d-grid gap-2 mt-3'>
              <button
                type='button'
                className='btn'
                style={{ backgroundColor: '#00719F', color: '#FFFFFF' }}
                onClick={() => {
                  Reset()
                }}
              >
                reset password
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
